export function buyerAdvisoryCommercialCP826() {
return [   // Release 2026-09-08 12:04:30
 
{
   page: 0,
   name: "Agent Brokerage Firm Name 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.64,
   height: 10.08
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 161.4,
   left: 166.56,
   width: 356.28,
   height: 10.08
}
,
{
   page: 0,
   name: "Agent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 188.16,
   left: 166.56,
   width: 356.28,
   height: 10.08
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 215.16,
   left: 166.56,
   width: 356.28,
   height: 10.08
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 749.52,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 150.12,
   width: 383.64,
   height: 10.08
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 749.52,
   left: 66.24,
   width: 300.36,
   height: 10.08
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 150.12,
   width: 383.64,
   height: 10.08
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 749.52,
   left: 66.24,
   width: 300.36,
   height: 10.08
}
,
{
   page: 3,
   name: "Agent Brokerage Firm Name 7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 150.12,
   width: 383.64,
   height: 10.08
}
,
{
   page: 3,
   name: "Agent Brokerage Firm Name 8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 749.52,
   left: 66.24,
   width: 300.36,
   height: 10.08
}
,
{
   page: 4,
   name: "Agent Brokerage Firm Name 9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 150.12,
   width: 383.64,
   height: 10.08
}
,
{
   page: 4,
   name: "Agent Brokerage Firm Name 10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 749.52,
   left: 66.24,
   width: 300.36,
   height: 10.08
}
,
{
   page: 5,
   name: "Agent Brokerage Firm Name 11", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 150.12,
   width: 383.64,
   height: 10.08
}
,
{
   page: 5,
   name: "Agent Brokerage Firm Name 12", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 749.52,
   left: 66.24,
   width: 300.36,
   height: 10.08
}
,
{
   page: 6,
   name: "Agent Brokerage Firm Name 13", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 150.12,
   width: 383.64,
   height: 10.08
}
,
{
   page: 6,
   name: "Agent Brokerage Firm Name 14", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 749.52,
   left: 66.24,
   width: 300.36,
   height: 10.08
}
,
{
   page: 7,
   name: "Agent Brokerage Firm Name 15", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 47.4,
   left: 150.775,
   width: 383.640,
   height: 11.16
}
,
{
   page: 7,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 557.8,
   left: 58.56,
   width: 378.24,
   height: 15.982
}
,
{
   page: 7,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 556.8,
   left: 441.72,
   width: 76.80,
   height: 15.982
}
,
{
   page: 7,
   name: "Signature Buyer CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 598.429,
   left: 59.56,
   width: 378.24,
   height: 14.673
}
,
{
   page: 7,
   name: "Date Signature Buyer CoAgent", 
   fontSize: 9,
   type: "date",
   top: 597.12,
   left: 442.72,
   width: 76.80,
   height: 15.982
}
,
{
   page: 7,
   name: "Agent Brokerage Firm Name 16", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 749.52,
   left: 66.24,
   width: 300.36,
   height: 10.08
}
] }
